import React, { createContext, useReducer, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => {
  return useContext(CartContext);
};

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_CART': {
      const existing = state.products.find(
        (product) => product.product_id === action.payload.product_id
      );
      if (existing) {
        return {
          ...state,
          products: state.products.map((product) =>
            product.product_id === action.payload.product_id
              ? {
                  ...product,
                  quantityToBuy:
                    (product.quantityToBuy || 1) +
                    (action.payload.quantityToBuy || 1),
                }
              : product
          ),
        };
      }
      return {
        ...state,
        products: [
          ...state.products,
          { ...action.payload, quantityToBuy: action.payload.quantityToBuy || 1 },
        ],
      };
    }

    case 'REMOVE_FROM_CART':
      return {
        ...state,
        products: state.products.filter(
          (product) => product.product_id !== action.payload.product_id
        ),
      };

    case 'UPDATE_QUANTITY':
      return {
        ...state,
        products: state.products.map((product) =>
          product.product_id === action.payload.productId
            ? { ...product, quantityToBuy: action.payload.quantityToBuy }
            : product
        ),
      };

    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, { products: [] });

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};
